export const supervisorcontratodeRole = {
  path: '/supcontra',
  redirect: 'noredirect',
  name: 'supcontra',
  single: false,
  meta: {
    title: 'SUPERVISOR CONTRATO',
    icon: 'audit',
    roles: ['super', 'admin', 'auditoria']
  }
}
export default supervisorcontratodeRole
